import * as yup from 'yup';
import { API as marina } from '../../marina/api';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { StatusDefault } from './Data.conf';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(isSameOrAfter);

export const CreateConf = {
  schema: yup.object({
    id_yacht: yup.object().nullable().required('Yacht is required'),
    check_in_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      })
      .required('Check In is required'),
    check_out_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test(
        'end-after-start',
        "End date can't be before Start date",
        function (value) {
          const { start_date } = this.parent;

          if (!value || !start_date) return true;
          return dayjs.utc(value).isSameOrAfter(dayjs.utc(start_date));
        }
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      })
      .required('Check Out is required'),
    cash: yup.string(),
    booking_status: yup.object().nullable().required('Operational Status is required'),
    id_marina: yup.object().nullable().required('Marina is required'),
    note: yup.string().nullable(),
  }),
  defaultValues: {
    id_yacht: null,
    check_in_date: dayjs().hour(15).minute(0).second(0).millisecond(0),
    check_out_date: dayjs().add(1, 'day').hour(12).minute(0).second(0).millisecond(0),
    cash: false,
    booking_status: null,
    id_marina: null,
    note: '',
  },
  fields: [
    {
      id: 'date_divider',
      type: 'divider',
      label: 'Check In & Check Out',
      xs: 12,
    },
    {
      id: 'check_in_date',
      name: 'check_in_date',
      type: 'date_time',
      label: 'Check In',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'check_out_date',
      name: 'check_out_date',
      type: 'date_time',
      label: 'Check Out',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'status_divider',
      type: 'divider',
      label: 'Marina',
      xs: 12,
    },
    {
      id: 'id_marina',
      name: 'id_marina',
      type: 'async_autocomplete',
      label: 'Marina',
      api: marina.select,
      required: true,
      xs: 12,
    },
    {
      id: 'status_divider',
      type: 'divider',
      label: 'Booking Info',
      xs: 12,
    },
    {
      id: 'booking_status',
      name: 'booking_status',
      type: 'autocomplete',
      label: 'Operational Status',
      options: StatusDefault,
      required: true,
      xs: 12,
      disableClearable: true,
    },
    {
      id: 'note',
      name: 'note',
      type: 'text',
      label: 'Note',
      xs: 12,
    },
    {
      id: 'note2',
      name: 'note2',
      type: 'text',
      label: 'Note 2',
      xs: 12,
    },
    {
      id: 'cash',
      name: 'cash',
      type: 'switch',
      label: 'Cash',
      xs: 12,
      sm: 12,
    },
  ],
};
